import React, { useState } from 'react';

import {
  Form,
  FormControl,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import Button from '../button/Button';

import ModalTerms from './ModalTerms';

import { Link } from 'react-router-dom';

import gmailImage from '../../../assets/gmail.png';
import information from '../../../assets/information.png';

import './CreateAccountForm.scss';

const CreateAccountForm = ({
  user,
  register,
  handleSubmit,
  errors,
  createAccount,
  watchShowAge,
  showTerms,
  setShowTerms,
  handleClose,
  isProfileFinished,
  userEmail,
  finishProfileHandler,
}) => {
  const isCreatingAccount = isProfileFinished === null && !userEmail;
  const isFinishingProfile = isProfileFinished === false;
  const checkName = () => {
    if (isCreatingAccount) return 'Create Account';
    if (isFinishingProfile) return 'Finish Profile';
    return 'Save';
  };

  return (
    <div className="createAccount__form">
      <div className="createAccount__header">
        <div className="createAccount__header-icon">
          <i className="fas fa-user-plus" />
        </div>
        <h1>{isCreatingAccount ? 'Join PlaySport USA' : checkName()}</h1>
        {isCreatingAccount && (
          <p>Create your free coach account and start recruiting international talent today.</p>
        )}
      </div>
      <Form
        onSubmit={
          isProfileFinished === null && !user
            ? handleSubmit(createAccount)
            : handleSubmit(finishProfileHandler)
        }
      >
        {/* Section 1: Account credentials */}
        <div className="ca-section">
          <div className="ca-section__header">
            <i className="fas fa-envelope" />
            <span>Account Details</span>
          </div>
          <div className="ca-section__grid">
            <div className="ca-field">
              <Form.Label>
                University e-mail
                <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                  <span className="section__req"> *</span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                className={errors.universityEmail && 'is-invalid'}
                ref={register}
                name="universityEmail"
                placeholder="name@university.edu"
              />
              <p className="validationError">{errors?.universityEmail?.message}</p>
            </div>

            <div className="ca-field">
              <Form.Label>
                <img className="gmail-logo" src={gmailImage} alt="gmail logo" />
                <OverlayTrigger
                  overlay={
                    <Tooltip className="google-tooltip">
                      Provide your google e-mail to login with just one click!
                    </Tooltip>
                  }
                >
                  <span className="section__req">
                    <img
                      className="information-logo"
                      src={information}
                      alt="information alert logo"
                    />
                  </span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                className={errors.personalEmail && 'is-invalid'}
                ref={register}
                name="personalEmail"
                defaultValue={isCreatingAccount ? '' : userEmail}
                placeholder="name@gmail.com"
              />
              <p className="validationError">{errors?.personalEmail?.message}</p>
            </div>
          </div>

          {(isCreatingAccount || isFinishingProfile) && (
            <div className="ca-section__grid">
              <div className="ca-field">
                <Form.Label>
                  Password
                  <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                    <span className="section__req"> *</span>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  className={errors.password && 'is-invalid'}
                  ref={register}
                  name="password"
                  type="password"
                  placeholder="••••••••"
                />
                <p className="validationError">{errors?.password?.message}</p>
              </div>
              <div className="ca-field">
                <Form.Label>
                  Confirm Password
                  <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                    <span className="section__req"> *</span>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="password"
                  className={errors.confirmPassword && 'is-invalid'}
                  name="confirmPassword"
                  ref={register}
                  placeholder="••••••••"
                />
                <p className="validationError">
                  {errors?.confirmPassword?.message}
                </p>
              </div>
            </div>
          )}
        </div>

        {/* Section 2: Personal info */}
        <div className="ca-section">
          <div className="ca-section__header">
            <i className="fas fa-id-card" />
            <span>Personal Information</span>
          </div>
          <div className="ca-section__grid">
            <div className="ca-field">
              <Form.Label>
                First name
                <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                  <span className="section__req"> *</span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                className={errors.firstName && 'is-invalid'}
                ref={register}
                name="firstName"
                placeholder="John"
              />
              <p className="validationError">{errors?.firstName?.message}</p>
            </div>
            <div className="ca-field">
              <Form.Label>
                Last name
                <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                  <span className="section__req"> *</span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                className={errors.lastName && 'is-invalid'}
                ref={register}
                name="lastName"
                placeholder="Doe"
              />
              <p className="validationError">{errors?.lastName?.message}</p>
            </div>
          </div>
          <div className="ca-section__grid">
            <div className="ca-field">
              <Form.Label>
                Job title
                <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                  <span className="section__req"> *</span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                className={errors.jobTitle && 'is-invalid'}
                ref={register}
                name="jobTitle"
                placeholder="Head Coach"
              />
              <p className="validationError">{errors?.jobTitle?.message}</p>
            </div>
            <div className="ca-field">
              <Form.Label>
                Cell phone
                <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                  <span className="section__req"> *</span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                className={errors.cellPhone && 'is-invalid'}
                ref={register}
                name="cellPhone"
                placeholder="+1 (555) 000-0000"
              />
              <p className="validationError">{errors?.cellPhone?.message}</p>
            </div>
          </div>
          <div className="ca-section__grid ca-section__grid--single">
            <div className="ca-field">
              <Form.Label>WhatsApp</Form.Label>
              <Form.Control
                className={errors.whatsApp && 'is-invalid'}
                ref={register}
                name="whatsApp"
                placeholder="+1 (555) 000-0000"
              />
              <p className="validationError">{errors?.whatsApp?.message}</p>
            </div>
          </div>
        </div>

        {/* Section 3: School info */}
        <div className="ca-section">
          <div className="ca-section__header">
            <i className="fas fa-university" />
            <span>School & Team</span>
          </div>
          <div className="ca-section__grid">
            <div className="ca-field">
              <Form.Label>
                School name
                <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                  <span className="section__req"> *</span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                className={errors.schoolName && 'is-invalid'}
                ref={register}
                name="schoolName"
                placeholder="University name"
              />
              <p className="validationError">{errors?.schoolName?.message}</p>
            </div>
            <div className="ca-field">
              <Form.Label>
                Size of school
                <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                  <span className="section__req"> *</span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                className={errors.sizeOfSchool && 'is-invalid'}
                ref={register}
                name="sizeOfSchool"
                placeholder="e.g. 5000"
              />
              <p className="validationError">{errors?.sizeOfSchool?.message}</p>
            </div>
          </div>
          <div className="ca-section__grid">
            <div className="ca-field">
              <Form.Label>
                Team division
                <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                  <span className="section__req"> *</span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                as="select"
                className={errors.teamDivision && 'is-invalid'}
                ref={register}
                name="teamDivision"
              >
                <option value="-">Select division</option>
                <option value="NCAAD1">NCAA D1</option>
                <option value="NCAAD2">NCAA D2</option>
                <option value="NAIA">NAIA</option>
                <option value="NJCAA">NJCAA</option>
                <option value="Other">Other</option>
              </Form.Control>
              <p className="validationError">{errors?.teamDivision?.message}</p>
            </div>
            <div className="ca-field">
              <Form.Label>
                Conference name
                <OverlayTrigger overlay={<Tooltip>Required!</Tooltip>}>
                  <span className="section__req"> *</span>
                </OverlayTrigger>
              </Form.Label>
              <Form.Control
                className={errors.conferenceName && 'is-invalid'}
                ref={register}
                name="conferenceName"
                placeholder="Conference name"
              />
              <p className="validationError">{errors?.conferenceName?.message}</p>
            </div>
          </div>

          {watchShowAge === 'NCAAD1' && (
            <div className="ca-section__grid ca-section__grid--single">
              <div className="ca-field">
                <Form.Label>RPI</Form.Label>
                <Form.Control
                  as="select"
                  className={errors.RPI && 'is-invalid'}
                  ref={register}
                  name="RPI"
                >
                  <option>1-100</option>
                  <option>101-200</option>
                  <option>201+</option>
                </Form.Control>
                <p className="validationError">{errors?.rpi?.message}</p>
              </div>
            </div>
          )}

          <div className="ca-section__grid">
            <div className="ca-field">
              <Form.Label>State</Form.Label>
              <FormControl
                className={errors.state && 'is-invalid'}
                ref={register}
                name="state"
                placeholder="e.g. California"
              />
              <p className="validationError">{errors?.state?.message}</p>
            </div>
            <div className="ca-field">
              <Form.Label>City</Form.Label>
              <FormControl
                className={errors.city && 'is-invalid'}
                ref={register}
                name="city"
                placeholder="e.g. Los Angeles"
              />
              <p className="validationError">{errors?.city?.message}</p>
            </div>
          </div>
        </div>

        {/* Terms + Submit */}
        <div className="ca-section ca-section--footer">
          {(isCreatingAccount || isFinishingProfile) && (
            <div className="ca-terms">
              <Form.Check
                ref={register}
                type="checkbox"
                name="terms"
                className={errors.terms && 'is-invalid'}
                id="terms-checkbox"
              />
              <Form.Label
                htmlFor="terms-checkbox"
                onClick={() => setShowTerms(true)}
                className="CreateAccount__terms"
              >
                I agree to the Terms of Service *
              </Form.Label>
              <p className="validationError">{errors?.terms?.message}</p>
            </div>
          )}
          {showTerms && (
            <ModalTerms closeModal={handleClose} showTerms={showTerms} />
          )}
          
          <Button
            type="submit"
            variant="primary"
            className="CreateAccount__button"
          >
            {checkName()}
          </Button>
        </div>

        {isCreatingAccount && (
          <div className="ca-login-link">
            <span>Already have an account?</span>
            <Link to="/login" className="ca-login-link__btn">Login</Link>
          </div>
        )}
      </Form>
    </div>
  );
};

export default CreateAccountForm;
